module.exports = __webpack_public_path__ + "static/media/boomBassador-icon-black.30aef3ce.png";